import { CIcon } from '~/icons/types'
export const ciLeaderboard: CIcon = {
  width: 4500,
  height: 4600,
  paths: [
    {
      d:
        'M22 5017c-19-21-22-34-22-119 0-53 3-104 6-113 13-33 59-45 179-45h115v-462c0-441 1-464 20-503 13-26 34-49 59-63 39-22 41-22 620-22h581v1050h230v-995c0-1093-4-1025 60-1079l32-26h1316l32 26c64 54 60-14 60 1079v995h230V3309l589 3c578 3 590 3 617 24 15 11 37 33 48 48 21 27 21 39 24 692l2 664h116c119 0 165 12 178 45 3 9 6 60 6 114 0 89-2 99-23 119l-23 22H43l-21-23z'
    },
    {
      d:
        'M2057 1836c-41-15-82-48-99-81-28-51-27-89 9-303l36-213-155-157c-86-86-164-172-173-191-25-50-16-129 19-176 43-56 90-72 315-104 112-17 204-31 206-33 1-2 44-86 95-188 119-239 148-270 250-270s131 31 250 270c51 102 94 187 96 189s94 16 206 32c224 32 271 48 314 104 35 47 44 126 19 176-9 19-87 105-173 191l-155 157 36 213c36 215 37 251 9 305-31 57-123 101-185 88-18-4-119-52-225-106l-192-100-193 100c-204 106-248 120-310 97z'
    }
  ],
  name: 'leaderboard',
  type: 'solid'
}
